//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SplitView from '~/components/SplitView.vue';
import ButtonRouter from '@/shared/components/ButtonRouter.vue';

export default {
  name: 'SplitViewSections',
  components: {
    SplitView,
    ButtonRouter,
  },
  methods: {
    isReverseOrder(index) {
      return !(index % 2 === 0);
    },
  },
  computed: {
    sections() {
      return [
        {
          src: '/v4/fc-home-kid-workout-stats-001.png',
          alt: 'boy punching using FightCamp app',
          header: 'Our Best Features Unlocked',
          text: 'FightCamp workouts make you sweat, but the FightCamp Punch Trackers keep you motivated. Compete, experience advanced drills & challenge modes, and get real-time scores & results. These features are only possible with the FightCamp Punch Trackers.',
          ctaText: 'Explore Packages',
          ctaPath: '/shop/',
        },
        {
          src: '/v4/fc-trackers-man-punching-bag-002.png',
          alt: 'man punching using FightCamp app on tv screen in home',
          header: 'It\'s Better With The Bag',
          text: 'Shadowboxing is a great start, but to get stronger, you need a punching bag. Practice better technique, add resistance to build muscle, and relieve more stress after hitting the bag. FightCamp\'s Free-Standing Bag is the most durable & convenient on the market. Made to look great in your home, and built for the toughest fighters.',
          ctaText: 'Explore Packages',
          ctaPath: '/shop/',
        },
        {
          src: '/v4/fc-trackers-home-set-up-001.jpeg',
          alt: 'Bag equipment in the home living room',
          header: 'Quality + Convenience',
          text: 'You won\'t find premium equipment like this just anywhere. FightCamp\'s thoughtfully-designed equipment packages ensure you have everything you need for our workouts, and you\'ll get it all delivered right to your home.',
          ctaText: 'Explore Packages',
          ctaPath: '/shop/',
        },
      ];
    },
  },
};
